import { render, staticRenderFns } from "./EvidenceReport.vue?vue&type=template&id=fadaba84&scoped=true&"
import script from "./EvidenceReport.vue?vue&type=script&lang=js&"
export * from "./EvidenceReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fadaba84",
  null
  
)

export default component.exports